import React, { useContext, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { LayoutContext } from '../../contexts'
import { getSegmentWriteKey } from '../../utils'
import SegmentConsentManager from './consentManager/SegmentConsentManager'

/**
 * Because segment should send data to different Klaviyo accounts, we made
 * it possible to load different segment environments, based on locale
 */

const SegmentScript = ({ layout }) => {
  const { node_locale } = layout
  const writeKey = getSegmentWriteKey(node_locale)

  useEffect(() => {
    if (window.analytics && window.analytics.load && !window.analytics.invoked)
      analytics.load(`${writeKey}`)
  }, [])

  return (
    <>
      <Helmet>
        <script>
          {`
            !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://segment.stoxenergy.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${writeKey}";analytics.SNIPPET_VERSION="4.13.2";}}();
            `}
        </script>
      </Helmet>
      <SegmentConsentManager layout={layout} />
    </>
  )
}

export default SegmentScript
